import React from "react";
import styled from "styled-components";

const NavbarSection = ({ title, children, rest }) => (
  <StyledNavbarSection {...rest} role="menu">
    <StyledNavbarSectionTitle>{title}</StyledNavbarSectionTitle>
    {children}
  </StyledNavbarSection>
);

const StyledNavbarSection = styled.ul`
  margin-top: 20px;
  margin-left: 20px;
  list-style: none;
`;

const StyledNavbarSectionTitle = styled.li`
  color: ${props => props.theme["$blue-gray-2"]};
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.8px;
  margin-bottom: 8px;
`;

export default NavbarSection;
